import React from "react";
import PropTypes from "prop-types";
import { DownIcon, UpIcon } from "./Icons";
import { FeedbackIcon } from "../FeedbackIcon";

import { NativeDropdown } from "@learningblocks/storybook-components/lib/NativeDropdown";

export function DropdownCell(props) {
    const onChange = ({ value }) => {
        props.onChange({ id: props.id, value, answer: props.answer, numberOfInputs: props.numberOfInputs, feedback: props.feedback });
    };

    const setClassName = () => {
        let className = props.className;
        if (props.showFeedback) {
            className += ` ${props.isCorrect ? "correctOption" : "incorrectOption"}`;
        }
        return className;
    };

    const isSelected = () => {
        return typeof props.value !== "undefined";
    };

    return (
        <td className={setClassName()} colspan={props.colspan}>
            <div
                className={`dataTable_row_cell_contents`}
                style={{
                    background: isSelected() && !props.showFeedback ? "#F5F7F9" : null,
                }}>
                <NativeDropdown
                    placeholder={props.placeholder}
                    className={`${props.className}_dropdown`}
                    options={props.options}
                    value={props.value}
                    onChange={onChange}
                    disabled={props.disabled}
                    iconOpen={DownIcon}
                    iconClose={UpIcon}
                />
                <FeedbackIcon isSuccess={props.isCorrect} showFeedback={props.showFeedback} className={`${props.className}_feedback`} feedback={props.feedback} />
            </div>
        </td>
    );
}

DropdownCell.propTypes = {
    /**
     * Unique Id for the cell
     */
    id: PropTypes.string,
    /**
     * placeholder for the cell
     */
    placeholder: PropTypes.string,
    /*
     * className to be set on component
     */
    className: PropTypes.string,
    /**
     * Options associated with drodown
     */
    options: PropTypes.arrayOf(
        PropTypes.shape({
            /**
             * value of the option
             */
            value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            /**
             * Label for option
             */
            label: PropTypes.string,
        })
    ),
    /*
     * Currently selected option value
     */
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * Funciton to invoke when an option is selected
     */
    onChange: PropTypes.func,
    /**
     * Boolean to check if the dropdown is disabled
     */
    disabled: PropTypes.bool,
    /**
     * Boolean feedback on value being correct/incorrect
     */
    isCorrect: PropTypes.bool,
};
